import { Controller } from "@hotwired/stimulus"

// Toggles the Tasks section on the Site show page between the embedded task list
// (default) and the stat-card overview. No persistence: each page load defaults
// to the list view.
export default class extends Controller {
  static targets = ["list", "cards", "listBtn", "cardsBtn"]

  showList() {
    this.activate("list")
  }

  showCards() {
    this.activate("cards")
  }

  activate(view) {
    const list = view === "list"
    this.listTarget.classList.toggle("hidden", !list)
    this.cardsTarget.classList.toggle("hidden", list)
    this.setActive(this.listBtnTarget, list)
    this.setActive(this.cardsBtnTarget, !list)
  }

  setActive(btn, active) {
    btn.classList.toggle("bg-white", active)
    btn.classList.toggle("text-gray-900", active)
    btn.classList.toggle("shadow-sm", active)
    btn.classList.toggle("text-gray-500", !active)
  }
}
